import { LuShare2 } from '@react-icons/all-files/lu/LuShare2'
import React from 'react'

import Tooltip from 'components/ui/tooltip'

export default function ShareArrowIcon() {
  return (
    <Tooltip content={'Share'}>
      <LuShare2 size={20} />
    </Tooltip>
  )
}
